window.DeviceBookNow = {

    init() {

        const button = document.querySelector(
            "[data-book-now]"
        );

        if (!button) return;

        button.addEventListener(
            "click",
            this.submit.bind(this)
        );

    },

    async submit() {

    const booking = window.deviceBooking;

    const properties = {

        "Laptop":
            document.querySelector('[name="properties[Laptop]"]')?.value || "0",

        "Tablet":
            document.querySelector('[name="properties[Tablet]"]')?.value || "0",

        "Phone":
            document.querySelector('[name="properties[Phone]"]')?.value || "0",

        "Others Quantity":
            document.querySelector('[name="properties[Others Quantity]"]')?.value || "0",

        "Others Description":
            document.querySelector('[name="properties[Others Description]"]')?.value || "",

        "Certificate":
            document.querySelector('[data-summary-source="certificate"]:checked')?.value || "No",

        "Collection Date":
            document.getElementById("device-collection-date")?.value || "",

        "Full Name":
            document.querySelector('[name="properties[Full Name]"]')?.value || "",

        "Phone Number":
            document.querySelector('[name="properties[Phone Number]"]')?.value || "",

        "Property Type":
            document.querySelector('[name="properties[Property Type]"]')?.value || "",

        "Collection Address":
            document.querySelector('[name="properties[Collection Address]"]')?.value || "",

        "Postal Code":
            document.querySelector('[name="properties[Postal Code]"]')?.value || "",

        "Unit Number":
            document.querySelector('[name="properties[Unit Number]"]')?.value || ""
    };

    console.log("Device Booking");

    console.log(properties);

    // Clear stale booking data from other services.
    localStorage.removeItem("valet_booking_address");
    localStorage.removeItem("valet_booking_properties");

/*
|--------------------------------------------------------------------------
| Add Main Product
|--------------------------------------------------------------------------
*/

if (!window.ExXtraAddToCart) {

    console.error(
        "ExXtraAddToCart helper not found."
    );

    return;

}

await window.ExXtraAddToCart.add({

    variantId:

        Number(
            document.getElementById(
                "device-booking-variant-id"
            ).value
        ),

    quantity: 1,

    properties,

    /*
    |--------------------------------------------------------------------------
    | Checkout Shipping Address
    |--------------------------------------------------------------------------
    */

    address: {

        fullName:
            document.querySelector(
                '[name="properties[Full Name]"]'
            )?.value || "",

        phone:
            document.querySelector(
                '[name="properties[Phone Number]"]'
            )?.value || "",

        line1:
            document.querySelector(
                '[name="properties[Collection Address]"]'
            )?.value || "",

        line2: "",

        unit:
            document.querySelector(
                '[name="properties[Unit Number]"]'
            )?.value || "",

        postcode:
            document.querySelector(
                '[name="properties[Postal Code]"]'
            )?.value || ""

    },

    service:
        "device-destruction"

});

    }

};

/*
|--------------------------------------------------------------------------
| Initialise
|--------------------------------------------------------------------------
*/

document.addEventListener(

    "DOMContentLoaded",

    () => {

        window.DeviceBookNow.init();

    }

);
